import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaPlus, FaMinus } from "react-icons/fa";
import BreadCum from "../../components/breadcum";
import AOS from "aos";
import "aos/dist/aos.css"; // Importar estilos de AOS

const faqs = [
  {
    question: "¿Por qué elegir Border Protect Seguridad Privada?",
    answer:
      "Nuestra experiencia, certificaciones oficiales y equipo altamente capacitado garantizan un servicio confiable y eficaz. Ofrecemos soluciones personalizadas y adaptadas a las necesidades de cada cliente.",
  },
  {
    question: "¿Qué tipo de clientes pueden contratar sus servicios?",
    answer:
      "Trabajamos con empresas, instituciones, corporaciones, organismos gubernamentales y clientes particulares que requieran seguridad profesional. Nos adaptamos a diferentes sectores con estrategias específicas.",
  },
  {
    question: "¿Cuentan con cobertura fuera de Sonora?",
    answer:
      "Actualmente, nuestros servicios están enfocados en Sonora, pero estamos en proceso de expansión. Contáctanos para evaluar la viabilidad en tu ubicación.",
  },
  {
    question: "¿Cómo puedo contratar sus servicios?",
    answer:
      "Puedes comunicarte con nosotros a través de nuestros teléfonos, correo electrónico o visitarnos en nuestras oficinas para recibir una asesoría personalizada y una cotización ajustada a tus necesidades.",
  },
  {
    question: "¿Qué medidas de seguridad implementan para eventos?",
    answer:
      "Para la seguridad en eventos, diseñamos estrategias personalizadas, implementamos sistemas de control de acceso y contamos con personal especializado en manejo de multitudes y respuesta ante emergencias.",
  },
  {
    question: "¿Cómo garantizan la capacitación de su personal?",
    answer:
      "Nuestro equipo recibe formación continua en técnicas de vigilancia, primeros auxilios, control de accesos y manejo de emergencias. Además, contamos con certificaciones oficiales que avalan nuestra capacitación.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    AOS.init({ duration: 800, easing: "ease-in-out", once: true });
  }, []);

  return (
    <section className="mx-auto max-w-screen-2xl px-6 lg:px-8 my-24">
      <div data-aos="fade-up">
        <BreadCum text="Preguntas Frecuentes" />
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 leading-tight mb-5">
          Preguntas Frecuentes
        </h1>
      </div>

      <div className="flex flex-col md:grid md:grid-cols-12 gap-12 items-center">
        {/* Sección de introducción y foto */}
        <div className="md:col-span-6 w-full" data-aos="fade-right">
          <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
            Sabemos que la seguridad es un tema crucial y que elegir la empresa
            adecuada puede generar muchas preguntas. Por eso, hemos reunido las
            dudas más comunes de nuestros clientes para ofrecerte la mejor
            orientación.
          </p>
          <img
            src="/img/landing/faq.webp"
            className="rounded-lg mt-5 hidden md:block w-full"
            alt="Seguridad"
          />
        </div>

        {/* Sección de preguntas y respuestas */}
        <div className="md:col-span-6 w-full">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border-b border-gray-300 last:border-none"
              data-aos="fade-left"
            >
              <button
                className={`w-full flex justify-between items-center text-lg md:text-xl font-semibold rounded-xl transition-all duration-300 hover:bg-red-600 group p-4 md:p-5 hover:text-white ${
                  openIndex === index ? "bg-red-600 text-white" : "bg-white text-gray-800"
                }`}
                onClick={() => toggleFAQ(index)}
              >
                {faq.question}
                {openIndex === index ? (
                  <FaMinus className="text-white text-2xl" />
                ) : (
                  <FaPlus className="text-2xl group-hover:text-white" />
                )}
              </button>

              {/* Respuesta con animación */}
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{
                  opacity: openIndex === index ? 1 : 0,
                  height: openIndex === index ? "auto" : 0,
                }}
                transition={{ duration: 0.3 }}
                className="text-gray-700 text-base md:text-lg"
              >
                <p className="py-3 px-4">{faq.answer}</p>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
